import { createApp } from 'vue'
import MapInput from '../vue/MapInput.vue'

export default class Map {

    static init(e) {
        const containerElement = e.detail.element;
        const els = containerElement.querySelectorAll('[data-map]');

        els.forEach((el) => new this(el));
    }

    constructor(el) {
        this.el = el;

        const app = createApp({
            components: {
                MapInput
            }
        })
        app.mount(this.el);
    }
}